var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_vm._l((_vm.extensionsObj),function(ext,index){return (ext.enabled)?[_c('v-col',{attrs:{"cols":"12","md":"6"}},[_c('v-card',[_c('v-card-title',[_vm._v(_vm._s(ext.name)+":")]),_c('div',{directives:[{name:"viewer",rawName:"v-viewer"}],staticClass:"images"},[_c('img',{attrs:{"src":_vm.getChecklistPicture(ext)}})])],1)],1)]:_vm._e()})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }